import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-646a533a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" }, null, -1))
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "p-mb-2 p-mt-1 p-text-bold p-text-uppercase",
  style: {"color":"#004C97"}
}
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = { class: "p-mr-2 p-text-uppercase" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " TO : ", -1))
const _hoisted_10 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " VOUCHER NO : ", -1))
const _hoisted_12 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " DATE : ", -1))
const _hoisted_14 = { class: "p-grid" }
const _hoisted_15 = { class: "p-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Authorized Signatory ___________________ Accountant ___________________ ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "previewReceiptDailog",
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '100vw' },
    position: "top",
    class: "p-fluid p-m-0 p-dialog-maximized",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        type: "button",
        label: "Print",
        icon: "pi pi-print",
        class: "p-button-warning pull-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printReceipt()))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.items.storeName), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.items.storeAddress), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.items.storeEmail), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.items.storePhone), 1),
          _createElementVNode("h6", null, "License No : " + _toDisplayString(_ctx.items.storeLicense), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "company-logo",
            src: _ctx.getCompanyURL(),
            alt: "Company Logo"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.previewHeading), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.items.selectedProfile), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.items.voucherNo), 1)
          ]),
          _createElementVNode("span", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.items.voucherDate)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_DataTable, {
            value: _ctx.items.itemList,
            class: "p-datatable-sm p-datatable-gridlines"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                style: {"width":"60%"},
                class: "p-p-1",
                field: "accountName",
                header: "ACCOUNT NAME"
              }),
              (_ctx.showOnly == 'Both' || _ctx.showOnly == 'Debit')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    style: {"width":"20%"},
                    class: "p-p-1",
                    header: "DEBIT"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(slotProps.data.debitAmount)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showOnly == 'Both' || _ctx.showOnly == 'Credit')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    style: {"width":"20%"},
                    class: "p-p-1",
                    field: "creditAmount",
                    header: "CREDIT"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(slotProps.data.creditAmount)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("p", null, " Description : " + _toDisplayString(_ctx.items.description), 1),
      _hoisted_16
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}